import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=75764ce8&scoped=true&"
import script from "./productDetail.vue?vue&type=script&lang=js&"
export * from "./productDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=75764ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75764ce8",
  null
  
)

export default component.exports